<template>
<div>
  <div class="m-card">
    <div class="u-card-head">
      <div class="u-img-logo"></div>
      <!--STEM工作室-->
    </div>
    <!-- 登录 -->
    <div class="u-card-form" v-show="show=='login'">
      <!--登录-->
      <div class="u-form-title">
        欢迎登录STEM未来计划
      </div>
      <div class="u-form-row">
        <input type="input" v-model="formlogin.account" placeholder="请输入手机号码" maxlength="13" />
      </div>
      <div class="u-form-row">
        <input type="text" v-model="formlogin.picVerCode"  placeholder="请输入图片验证码"  style="width: 250px;vertical-align: bottom;"/>
        <img :src="formlogin.picVerCodeSrc" alt="" @click="getPicVerCode('login')">
      </div>
      <div class="u-form-row">
        <div class="u-form-cell-3">
          <input v-model="formlogin.smsCode" placeholder="请输入短信验证码" />
        </div>
        <div class="u-form-cell-1">
          <button :class="{disable:!canGetVCodeLogin||time_out_login}" @click="getVCodeLogin()">
            <span v-show="time_out_login == 0">
              获取验证码
            </span>
            <span v-show="time_out_login!=0">
              {{time_out_login}}秒
            </span>
          </button>
        </div>
      </div>


      <div class="u-form-row">
        <input type="password" v-model="formlogin.password"  placeholder="密码" autocomplete="new-password" />
      </div>
      <div class="u-form-row">
        <button :class="{disable:!canLoginBySms}" @click="loginBySms">登录</button>
      </div>
    </div>
    <!-- 注册，功能取消 -->
    <div class="u-card-form" v-show="show=='register'" style="margin-bottom: 2rem;">
      <!--注册-->
      <div class="u-form-title">
        用户注册
      </div>
      <div class="u-form-row" >
        <h1 style="font-size: 15px;color: red;">为提供更优质服务，系统已升级</h1>
        <p>请前往 <strong>青少年科学素养提升整体服务平台</strong>  进行访问</p>
        <a href="https://kxsy.ooowin.com" target="_blank" style="font-size: 24px;margin-top: 20px;display: block;"> 立即前往 </a>
      </div>
      <div class="go-login clearfix u-form-row" style="margin-top: 60px;">
        <a class="fr" @click="setShow('login')" style="color: #10949e;font-size: 16px;margin: 0 8px;cursor: pointer;">已有帐号登录</a>
        <!-- <p style="text-align: right;">咨询电话：0571-88909745</p> -->
      </div>
      <div class="u-form-row" v-if="false">
        <input type="input" v-model="formRegister.phone" placeholder="请输入手机号码" maxlength="13" />
      </div>
      <div class="u-form-row" style="display: flex;justify-content: space-between;" v-if="false">
          <input type="text" v-model="formRegister.picVerCode"  placeholder="请输入图片验证码"  style="width: 250px;vertical-align: bottom;"/>
          <img :src="formRegister.picVerCodeSrc" alt="" @click="getPicVerCode('register')">
      </div>
      <div class="u-form-row" v-if="false">
        <div class="u-form-cell-3">
          <input v-model="formRegister.code" placeholder="请输入验证码" />
        </div>
        <div class="u-form-cell-1">
          <button :class="{disable:!canGetVCode1||time_out1}" @click="getVCode(1)">
            <span v-show="time_out1 == 0">
              获取验证码
            </span>
            <span v-show="time_out1!=0">
              {{time_out1}}秒
            </span>
          </button>
        </div>
      </div>
      <div class="u-form-row" v-if="false">
        <input type="password" v-model="formRegister.password" placeholder="密码应为8-20位，至少包含大小写字母、数字和特殊符号" />
      </div>

      <div class="u-form-row" v-if="false">
        <input type="password" v-model="formRegister.password2" placeholder="请再次输入密码" />
      </div>
      <br>
      <div class="u-form-row" v-if="false">
        <button :class="{disable:!canRegister}" @click="register">注册</button>
      </div>
      <div class="u-form-row" v-if="false">
        <span class="u-tip">注册即代表同意 <a href="./agreement.html" target="_blank">《用户协议》</a></span>
      </div>
    </div>
    <!-- 忘记密码，功能取消 -->
    <div class="u-card-form" v-show="show=='forgot'" style="margin-bottom: 3rem;" >
      <div class="u-form-title">
        忘记密码
      </div>

      <div class="u-form-row">
        <input type="input" v-model="formForgot.phone" placeholder="请输入手机号码" maxlength="13" />
      </div>
      <div class="u-form-row" style="display: flex;justify-content: space-between;">
          <input type="text" v-model="formForgot.picVerCode"  placeholder="请输入图片验证码"  style="width: 250px;vertical-align: bottom;"/>
          <img :src="formForgot.picVerCodeSrc" alt="" @click="getPicVerCode('forgot')">
      </div>
      <div class="u-form-row">
        <div class="u-form-cell-3">
          <input type="text" v-model="formForgot.code" placeholder="输入验证码" />
        </div>
        <div class="u-form-cell-1">
          <button :class="{disable:!canGetVCode2||time_out2}" @click="getVCode(2)">
            <span v-show="time_out2 == 0">
              获取验证码
            </span>
            <span v-show="time_out2!=0">
              {{time_out2}}秒
            </span>
          </button>
        </div>
      </div>
      <div class="u-form-row">
        <input type="password" v-model="formForgot.password" placeholder="设置密码" />
      </div>
      <div class="u-form-row">
        <input type="password" v-model="formForgot.password2" placeholder="再次输入密码" />
      </div>
      <br>
      <div class="u-form-row">
        <div class="u-form-cell-2">
          <button @click="setShow('login')">取消</button>
        </div>
        <div class="u-form-cell-2">
          <button :class="{disable:!canForgot}" @click="resetPwd">确认</button>
        </div>
      </div>
    </div>
    <div class="u-card-bottom" v-show="show=='login'">
      <a class="u-a-1" v-show="show!='register'" @click="setShow('register')">还没有云帐号？马上注册吧</a>
      <a class="u-a-1" v-show="show!='login'" @click="setShow('login')">已有帐号？去登录</a>
      <a v-show="show!='forgot'" @click="setShow('forgot')" v-if="false">忘记密码？</a>
    </div>
  </div>
</div>
</template>

<script>
import Cookies from 'js-cookie';
import { JAjax, Base, getQueryObject } from '@commonjs/base.js';
import { Base64 } from 'js-base64';
// import {JAjax,Base,getQueryObject,Cookies} from '@commonjs/base.js';
export default {
  name: 'Login',
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    show: {
      type: String,
      default: 'login',
    },
  },
  data() {
    return {
      formlogin: {
        account: '',
        password: '',
        smsCode: '',
        picVerCode:'',
        picVerCodeSrc:'',
        picVerCodeKey:''
      },
      // fromUrl:'',
      formRegister: {
        phone: '',
        code: '',
        password: '',
        password2: '',
        picVerCode:'',
        picVerCodeSrc:'',
        picVerCodeKey:''
      },
      formForgot: {
        phone: '',
        code: '',
        password: '',
        password2: '',
        picVerCode:'',
        picVerCodeSrc:'',
        picVerCodeKey:''
      },
      time_out1: 0,
      time_out2: 0,
      time_out_login:0,
      timer1: null,
      timer2: null,
      timer_login:null,
      isVCodeSending: false, // 控制验证码是否正在发送中（防止重复点击）
    };
  },
  watch:{
    show:{
      deep:true,
      immediate: true,
      handler:function(show){
        console.log("--- login modal isshow---显示登录modal:" + show)
        if(!!show){
          console.log("---- 获取图形验证码1111 ----");  
          this.getPicVerCode(show)
        }
      }
    },
    isModal:{
      deep:true,
      immediate: true,
      handler:function(isModal){
        console.log("--- login modal isModal---显示登录modal:" + isModal)
        if(isModal){
          console.log("---- 获取图形验证码2222 ----");  
          this.getPicVerCode(this.show)
          // 如果定时器存在，清除它
          if (this.timer_login) {
            clearInterval(this.timer_login);
            this.timer_login = null;
            this.isVCodeSending = false; // 重置发送状态
            this.time_out_login = 0; // 重置倒计时
          }
        }
      }
    }
  },
  mounted: function () {
    // const urlObj = getQueryObject();
    // this.show = urlObj.show || this.show;
    // this.fromUrl = (window.location.href == document.referrer || !document.referrer) ? './index.html' : document.referrer;
    console.log("mounted--- login modal isshow---显示登录modal:" + this.show);
  },
  computed: {
    canLogin: function () {
      return this.formlogin.account != '' && this.formlogin.password != '' && this.formlogin.picVerCode != '';
    },
    canLoginBySms: function () {
      return this.formlogin.account != '' && this.formlogin.smsCode != '' && this.formlogin.password != '';
    },
    canGetVCode1() {
      return this.formRegister.phone.length > 10 && this.formRegister.picVerCode!="";
    },
    canGetVCode2() {
      return this.formForgot.phone.length > 10 && this.formForgot.picVerCode!="";
    },
    canGetVCodeLogin() {
      return this.formlogin.account.length > 10 && this.formlogin.picVerCode!="";
    },
    canRegister() {
      return (
        this.formRegister.phone != '' &&
        this.formRegister.code != '' &&
        this.formRegister.password != '' &&
        this.formRegister.password2 != ''
      );
    },
    canForgot() {
      return (
        this.formForgot.phone != '' &&
        this.formForgot.code != '' &&
        this.formForgot.password != '' &&
        this.formForgot.password2 != ''
      );
    },
  },
  methods: {
    getPicVerCode(show){
      JAjax.postJson(Base.webUrl + 'captcha/captcha', {}, res => {
				if (res.code == 1) {
          switch (show) {
            case "login":
              this.formlogin.picVerCodeSrc =  res.data.image
              this.formlogin.picVerCodeKey =  res.data.key
              break;
            case "register":
              this.formRegister.picVerCodeSrc =  res.data.image
              this.formRegister.picVerCodeKey =  res.data.key
              break;
            case "forgot":
              this.formForgot.picVerCodeSrc =  res.data.image
              this.formForgot.picVerCodeKey =  res.data.key
              break;
            default:
              break;
          }
				} else {
					this.$Message.warning(res.msg);
				}
			});
    },
    // 废弃
    login(type) {
      //console.log(Base64.encode(this.formlogin.password))
      let formData = {};
      if (type && type == 1 && !this.canLogin) {
        //type=1直接登录
        return;
      }
      if (type && type == 1) {
        formData = {
          phone: this.formlogin.account.replace(/\s/g, ''),
          password: Base64.encode(this.formlogin.password),
          verCode: this.formlogin.picVerCode,
          key:this.formlogin.picVerCodeKey
        };
      } else {
        //注册-》完善信息
        formData = {
          phone: this.formRegister.phone.replace(/\s/g, ''),
          password: Base64.encode(this.formRegister.password)
        };
      }
      this.$Loading.start();
      this.ajax.postForm(this.aUrl.login, formData).then(res => {
        console.log(res,res)
        this.$Loading.finish();
        Cookies.set('stem_ooowin_token', res.data.token, {
          expires: 7,
          path: ''
        });
        Cookies.set('stem_ooowin_mark', res.data.mark, {
          expires: 7,
          path: ''
        });
        if (res.data.hasName && this.isModal) {
          // location.reload();
          this.$Message.success('登录成功');
          //是否需要修改密码，1 不需要，2 需要
          Cookies.set('updatePwdFlag',res.data.updatePwdFlag);
          // 密码是否过于简单 ，1 复杂，不需要修改，2 过于简单，需要修改
          Cookies.set('stem_ooowin_pwdEasy',res.data.pwdEasy);
          //关闭当前的model
          this.$emit('login-in');
          
        } else {
          // window.location.href = './register_info.html';
            // location.reload();
            this.$Message.success('登录成功');
          //是否需要修改密码，1 不需要，2 需要
          Cookies.set('updatePwdFlag',res.data.updatePwdFlag);
          // 密码是否过于简单 ，1 复杂，不需要修改，2 过于简单，需要修改
          Cookies.set('stem_ooowin_pwdEasy',res.data.pwdEasy);
          //关闭当前的model
          this.$emit('login-in');
        }
      }).catch(err=>{
        console.log("err",err)
        if(err.code==10005){
        	this.$Message.warning(err.msg);
        }
      });
    },
    // 短信验证码登录
    loginBySms() {
      //console.log(Base64.encode(this.formlogin.password))
      let formData = {
          phone: this.formlogin.account.replace(/\s/g, ''),
          password: Base64.encode(this.formlogin.password),
          smsCode: this.formlogin.smsCode,
      };

      if (!this.canLoginBySms) {
        return;
      }

      this.$Loading.start();
      this.ajax.postForm(this.aUrl.loginBySms, formData).then(res => {
        console.log(res,res)
        this.$Loading.finish();
        Cookies.set('stem_ooowin_token', res.data.token, {
          expires: 7,
          path: ''
        });
        Cookies.set('stem_ooowin_mark', res.data.mark, {
          expires: 7,
          path: ''
        });
        if (res.data.hasName && this.isModal) {
          // location.reload();
          this.$Message.success('登录成功');
          //是否需要修改密码，1 不需要，2 需要
          Cookies.set('updatePwdFlag',res.data.updatePwdFlag);
          // 密码是否过于简单 ，1 复杂，不需要修改，2 过于简单，需要修改
          Cookies.set('stem_ooowin_pwdEasy',res.data.pwdEasy);
          //关闭当前的model
          this.$emit('login-in');
          
        } else {
          // window.location.href = './register_info.html';
            // location.reload();
            this.$Message.success('登录成功');
          //是否需要修改密码，1 不需要，2 需要
          Cookies.set('updatePwdFlag',res.data.updatePwdFlag);
          // 密码是否过于简单 ，1 复杂，不需要修改，2 过于简单，需要修改
          Cookies.set('stem_ooowin_pwdEasy',res.data.pwdEasy);
          //关闭当前的model
          this.$emit('login-in');
        }
      }).catch(err=>{
        console.log("err",err)
        if(err.code==10005){
        	this.$Message.warning(err.msg);
        }
      });
    },
    
    // 废弃
    getVCode(type) {
      //获取密码
      let phone = type == 1 ? this.formRegister.phone : this.formForgot.phone;
      let key = "";
      let verCode = ""
      if (type == 1 && !this.canGetVCode1) {
        return;
      } else if (type == 2 && !this.canGetVCode2) {
        return;
      }

      if (type == 1) {
        //注册
        key = this.formRegister.picVerCodeKey
        verCode = this.formRegister.picVerCode
        console.log('注册获取验证码')

      } else if (type == 2) {
        //忘记密码
        console.log('忘记密码获取验证码')
        key = this.formForgot.picVerCodeKey
        verCode = this.formForgot.picVerCode
      }

      this['time_out' + type] = 60;
      this['timer' + type] = setInterval(() => {
        this['time_out' + type]--;
        if (this['time_out' + type] == 0) {
          this['canGetVCode' + type] = true;
          clearInterval(this['timer' + type]);
        }
      }, 1000);
      this.$Loading.start();
      this.ajax
        .postForm(this.aUrl.get_code, {
          phone: phone,
          type: type,
          key,
          verCode
        })
        .then(res => {
          this.$Loading.finish();
        })
        .catch(err => {
          this['canGetVCode' + type] = true;
          clearInterval(this['timer' + type]);
          this['time_out' + type] = 0;
        });
    },
    getVCodeLogin() {
      console.log('登录获取验证码Start========')
      //获取登录验证码
      let phone = this.formlogin.account;
      let key = this.formlogin.picVerCodeKey
      let verCode = this.formlogin.picVerCode

      if (!this.canGetVCodeLogin) {
        return;
      }
      if (this.isVCodeSending) { 
        // 正在发送中，禁止重复点击
        return;
      }

        // 2. 发送状态+倒计时初始化
      this.isVCodeSending = true; // 标记为发送中，禁用按钮
      this.time_out_login = 60;
      // 清除旧定时器（避免多个定时器冲突）
      if (this.timer_login) clearInterval(this.timer_login);
      // 重新开始新的计时器
      this.timer_login = setInterval(() => {
        this.time_out_login--;
        if (this.time_out_login == 0) {
          clearInterval(this.timer_login);
          this.timer_login = null;
          this.isVCodeSending = false; // 倒计时结束，恢复发送状态
        }
      }, 1000);
      this.$Loading.start();
      this.ajax
        .postForm(this.aUrl.get_code, {
          phone: phone,
          type: 3,
          key,
          verCode
        })
        .then(res => {
          clearInterval(this.timer_login);
          console.log("登录获取验证码成功："+ res)
          this.$Loading.finish();
        })
        .catch(err => {
          console.log("登录获取验证码失败：")
          console.log(err)
          // 重新获取图形验证码
          this.getPicVerCode('login');
          // this.isVCodeSending = false; // 发送失败，恢复发送状态  
          // clearInterval(this.timer_login);
          // this.time_out_login = 0;
        });
    },
    register() {
      //注册
      if (!this.canRegister) {
        return;
      }
      //var reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$/
      var reg = /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/
      if (!reg.test(this.formRegister.password)) {
        this.$Message.error('密码应为8-20位，至少包含大小写字母、数字和特殊符号');
        return
      }

      if (this.formRegister.password != this.formRegister.password2) {
        this.$Message.error('两次密码不一致');
        return;
      }

      this.$Loading.start();
      let postData = JSON.parse(JSON.stringify(this.formRegister));
      postData.password = Base64.encode(postData.password)
      postData.password2 = Base64.encode(postData.password2)
      this.ajax.postForm(this.aUrl.register, postData).then(res => {
        this.$Loading.finish();
        this.$Message.success('恭喜你，注册成功');
        // this.login(2);
      });
    },
    resetPwd() {
      if (!this.canForgot) {
        return;
      }
       var reg = /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/
      if (!reg.test(this.formForgot.password)) {
        this.$Message.error('密码应为8-20位，至少包含大小写字母、数字和特殊符号');
        return;
      }
      if (this.formForgot.password != this.formForgot.password2) {
        this.$Message.error('两次密码不一致');
        return;
      }
      this.$Loading.start();
      let postData = JSON.parse(JSON.stringify(this.formForgot));
      postData.password = Base64.encode(postData.password)
      postData.password2 = Base64.encode(postData.password2)
      this.ajax.postForm(this.aUrl.reset_pwd, postData).then(res => {
        this.$Loading.finish();
        this.$Message.success('恭喜你，密码修改成功');
        setTimeout(() => {
          this.show = 'login';
          this.formForgot = {
            phone: '',
            code: '',
            password: '',
            password2: '',
          };
        }, 1000);
      });
    },
    setShow(name) {
      this.$emit('set-show', name);
    },
  },
};
</script>

<style lang="scss">
@import './new_login.scss';
</style>
